
import { IInvoice } from '@/types/models';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
});
